<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>

          <b-form-row>
            <b-col md="6">
              <b-form-group label="Ano / Mês Inicial">
                <b-form-input type="number" step="1" min="0" name="ym_start" v-model="item.ym_start" placeholder="Ano / Mês Inicial"  v-validate="'required'" :state="validateState('ym_start')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ym_start') }}
                </b-form-invalid-feedback>
              </b-form-group>

            </b-col>
            <b-col md="6">
              <b-form-group label="Ano / Mês Final">
                <b-form-input type="number" step="1" min="0" name="ym_end" v-model="item.ym_end" placeholder="Ano / Mês Final"  v-validate="'required'" :state="validateState('ym_end')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ym_end') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col md="4">
              <b-form-group label="ShipTo">
                <b-form-input type="text" name="ship_to" v-model="item.ship_to" placeholder="Shipto"  v-validate="'required'" :state="validateState('ship_to')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ship_to') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Zona">
                <b-form-input type="text" name="zone" v-model="item.zone" placeholder="Zona"  v-validate="'required'" :state="validateState('zone')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('zone') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

          </b-form-row>
          <b-form-row>
            <b-col md="3">
              <b-form-group label="SO">
                <b-form-input type="number" step="1" min="0" name="stars_so_code" v-model="item.stars_so_code" placeholder="SO"  v-validate="'required'" :state="validateState('stars_so_code')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('stars_so_code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="ST">
                <b-form-input type="number" step="1" min="0" name="stars_st_code" v-model="item.stars_st_code" placeholder="ST"  v-validate="'required'" :state="validateState('stars_st_code')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('stars_st_code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="CADV">
                <b-form-input type="number" step="1" min="0" name="stars_cadv_code" v-model="item.stars_cadv_code" placeholder="CHA"  v-validate="'required'" :state="validateState('stars_cadv_code')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('stars_cadv_code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="CHA">
                <b-form-input type="number" step="1" min="0" name="stars_cha_code" v-model="item.stars_cha_code" placeholder="CADV"  v-validate="'required'" :state="validateState('stars_cha_code')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('stars_cha_code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>



          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'ws_relations.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>{{ item }}</pre>

        </b-card>
      </b-col>
      <!--/.col-->

    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'BestofObjectiveEdit',
  props: ['id'],
  components: {  },
  data() {
    return {
      lists: lists,
      dataLoaded: false,
      item: {

        zone: {
          data: {
            id: null,
            name: ''
          }
        },
        ship_to: 0,
        stars_so_code: 0,
        stars_st_code: 0,
        stars_cha_code: 0,
        stars_cadv_code: 0
      }
    }
  },
  methods: {
    selectDealer(e) {
      this.item.dealer_id = e.item.id
      this.item.dealer.data = e.item
    },
    selectZone(e) {
      this.item.zone = e.item.zone
      this.$refs.dealersModal.hide()
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('stars/ws_relations' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'ws_relations.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('stars/ws_relations', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'ws_relations.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('stars/ws_relations' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
          if(!this.item.dealer) {
            this.item.dealer = {
              data: {}
            }
          }
          if(!this.item.zone) {
            this.item.zone = {
              data: {}
            }
          }
        })
        .catch(response => {
          this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'ws_relations.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
